import { render, staticRenderFns } from "./DealerDashboard.vue?vue&type=template&id=18efa482&"
import script from "./DealerDashboard.vue?vue&type=script&lang=js&"
export * from "./DealerDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports